import _slicedToArray from "/Users/phil/Workspace/petroff-billing-master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
var currencyFormatter = {};
currencyFormatter.formatUSD = function (value) {
  return !value || isNaN(value) ? '$0.00' : value.toLocaleString('en-us', {
    style: 'currency',
    currency: 'USD'
  }).replace('-', "\u2212");
};
currencyFormatter.dollarPad = function (amount) {
  if (!amount) {
    return '';
  }
  if (amount.includes('.')) {
    var _split = (amount + '00').split('.'),
      _split2 = _slicedToArray(_split, 2),
      dollar = _split2[0],
      cents = _split2[1];
    return dollar + '.' + cents.substr(0, 2);
  }
  return amount + '.00';
};
export default currencyFormatter;